import { Message } from 'element-ui';
import store from '@/store/index';
import Api from '@/api/index';
const state = {
  mode: 1, // 1正常模式 2编辑模式
  changeSetingList: [],
  sourceList: {}
};
const mutations = {
  SET_MODE: (state, targetStatus) => {
    state.mode = targetStatus;
  },
  UPDATE_SOURCE_LIST(state, { id, val, isEdit = false }) {
    state.sourceList = { ...state.sourceList, [id]: { val, isEdit } };
  },
  UPDATESETINGLIST(st, data) {
    // 更新设置列表数据
    const { id, FElpcStatus } = data;
    let idFlag = false;
    // ID存在则替换
    let mapchangeSetingList = st.changeSetingList.map(v => {
      if (v.id == id) {
        idFlag = true;
        return data;
      }
      return v;
    });
    if (!idFlag) {
      st.changeSetingList.push(data);
    } else {
      st.changeSetingList = mapchangeSetingList;
    }
    console.log(st.changeSetingList);
  },
  CLEARDATALIST(st) {
    // 清除编辑状态和数据
    st.changeSetingList = [];
    st.mode = 1;
    st.sourceList = {};
  },
  SUBMITSETTINGLIST(st) {
    // 提交变更
    store.dispatch('shopManagement/CLEARDATALIST');
  }
};

const actions = {
  UPDATESETINGLIST({ commit }, data) {
    commit('UPDATESETINGLIST', data);
  },
  CLEARDATALIST({ commit }) {
    commit('CLEARDATALIST');
  },
  async SUBMITSETTINGLIST({ commit, dispatch, state, rootState }) {
    // 保存成功后才会取消编辑状态
    let List = store.getters.getchangeSetingList;
    const sourceList = state.sourceList;

    console.log('List=', JSON.stringify(List), 'sourceList=', JSON.stringify(sourceList));

    for (let i = 0; i < List.length; i++) {
      const id = List[i].id;
      const feLpcStatus = List[i].FElpcStatus;

      if (sourceList[id] && !sourceList[id].val && feLpcStatus == 1) {
        Message.error('请选择要开启的审方中心');
        return;
      }
    }

    // const _sourceList = Object.entries(sourceList);
    //
    // for (let i = 0; i < _sourceList.length; i++) {
    //   const [id, source] = _sourceList[i];
    //   const changeItem = List.find(l => l.id == id);
    //
    //   if (!changeItem) {
    //   } else {
    //     if (changeItem.FElpcStatus != 1 && source.val && source.isEdit) {
    //       Message.error('请勾选开启审方中心');
    //       return;
    //     }
    //   }
    // }

    // if (List.length != Object.keys(sourceList).length) {
    //   Message.error('请勾选开关');
    //   return;
    // }

    if (List.length == 0) {
      // 无操作直接点击保存
      commit('CLEARDATALIST');
      return;
    }

    try {
      const permissionSetting = List.map(v => {
        let remotePharmacistStatus = v.FEremote;
        let storePharmacistStatus = v.FEpha;
        let faceStatus = v.FEface;
        let dispenseStatus = v.FEdispenseStatus;
        let dispatchStatus = v.FEdispatchStatus;
        let diagnoseBeforeAskStatus = v.FEDiagnoseBeforeAskStatus;
        let userPicStatus = v.FEUserPicStatus;
        let localPrescriptionsCenter = v.FElpcStatus == 1 && sourceList[v.id] ? sourceList[v.id].val : null; // 三方审方中心id
        return {
          storeId: v.id,
          remotePharmacistStatus,
          storePharmacistStatus,
          faceStatus,
          dispenseStatus,
          dispatchStatus,
          diagnoseBeforeAskStatus,
          localPrescriptionsCenter,
          userPicStatus
        };
      });
      Telescope.trackEvent({ trackId: 'zywzpc-shop-update-setting', custom: { permissionSetting } });

      await Api.updateStoreSetting({ permissionSetting });

      commit('CLEARDATALIST');
      await dispatch('permission/getInfo', null, { root: true });
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
